export default "__VITE_ASSET__1gr1ypxz__"